"use client";

import Script from "next/script";

const ConsentDefaults = () => {
  if (process.env.NODE_ENV !== "production") return null;

  return (
    //eslint-disable-next-line
    <Script id="consent-defaults" strategy="beforeInteractive">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('consent', 'default', {
          ad_storage: 'denied',
          analytics_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied'
        });
      `}
    </Script>
  );
};

export { ConsentDefaults };
